// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3248r","imageUploader":"EGiftCard_imageUploader__3chPZ"};